export default __webpack_public_path__ + "static/media/delete-blue.a25707b0.svg";